export const PAYMENT_PROVIDER_OPN = 'OPN'
export const PAYMENT_PROVIDER_STRIPE = 'STRIPE'
export const PAYMENT_PROVIDER_TRANZILA = 'TRANZILA'
export const PAYMENT_PROVIDER_TOTAL_PROCESSING = 'TOTAL_PROCESSING'

// Our Opn account is registered in TH: card (and the Google Pay wallet, which
// tokenises into a card) can be presented in any of Opn's supported currencies,
// but every other rail — PromptPay, LINE Pay, TrueMoney, WeChat, mobile banking —
// is THB-only. A non-THB venue must therefore be offered cards only, or the
// widget produces a source the charge endpoint has to reject.
// Source: GET https://api.omise.co/capability
export const OPN_DEFAULT_CURRENCY = 'THB'
export const OPN_MULTI_CURRENCY_PAYMENT_METHODS = ['credit_card', 'googlepay']

const PAID = 'paid'
const ACTIVE = 'active'
const INACTIVE = 'inactive'
const CANCELLED = 'cancelled'
const IN_PROCESS = 'inprocess'
const PAYMENT_TIME_OUT = 'timeout'
const PAYMENT_FAILED = 'payment_failed'
const USER_INPROCESS_WITH_QR = 'userInprocessWithQr'
export const POS_TERMINAL_STATUSES = {
  PAID,
  ACTIVE,
  INACTIVE,
  CANCELLED,
  IN_PROCESS,
  PAYMENT_FAILED,
  PAYMENT_TIME_OUT,
  USER_INPROCESS_WITH_QR
}
